import type { Address } from 'viem'
import { formatAddress } from '../utils'

export function RemoveControllerModal({
  isOpen,
  onClose,
  onConfirm,
  controllerAddress,
  isConfirmDisabled,
}: {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  controllerAddress: Address
  isConfirmDisabled?: boolean
}) {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      <div className="absolute inset-0 flex items-center justify-center p-4">
        <div className="w-full max-w-md rounded-xl border border-white/5 bg-surface shadow-2xl">
          <div className="px-6 py-5 border-b border-white/10">
            <div className="flex items-start justify-between gap-4">
              <div className="min-w-0">
                <div className="text-xs uppercase tracking-widest text-gray-500">
                  Remove controller
                </div>
                <h3 className="text-lg font-semibold text-gray-100 mt-1">Remove this controller completely?</h3>
                <p className="text-sm text-gray-400 mt-1">
                  This will clear its permissions from your Universal Profile.
                </p>
              </div>
              <button
                onClick={onClose}
                className="p-2 rounded-xl text-gray-400 hover:text-white hover:bg-white/10 transition-colors"
                aria-label="Close"
              >
                <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>

          <div className="px-6 py-5">
            <div className="rounded-xl border border-white/[0.08] bg-white/[0.04] p-4">
              <div className="text-xs text-gray-500">Controller</div>
              <div className="mt-1 font-mono text-sm text-gray-200">{formatAddress(controllerAddress, 8)}</div>
            </div>

            <div className="mt-4 rounded-xl border border-red-500/30 bg-red-500/10 p-4">
              <div className="text-sm font-semibold text-red-200">This action cannot be undone</div>
              <div className="text-xs text-red-200/90 mt-1">
                The controller will lose all permissions. You can re-add it later if needed.
              </div>
            </div>
          </div>

          <div className="px-6 py-5 border-t border-white/10 flex items-center justify-end gap-2">
            <button onClick={onClose} className="btn-secondary">
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="btn-danger"
              disabled={isConfirmDisabled}
            >
              Remove controller
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
